import React, { useCallback } from "react";
import { connect } from "react-redux";

import { ICellRendererParams } from "@ag-grid-community/core";
import { useIntl } from "react-intl";

import { EntityType } from "@mapmycustomers/shared/types/entity";

import EntityChip from "@app/component/EntityChip";
import useRowHeightUpdater from "@app/component/grid/util/hooks/useRowHeightUpdater";
import { showEntityView } from "@app/store/entityView/actions";

interface Props extends ICellRendererParams {
  onShowEntityView: typeof showEntityView;
}

const PrimaryPersonCellRenderer: React.FC<Props> = ({ api, node, onShowEntityView, value }) => {
  useRowHeightUpdater(node, api);
  const intl = useIntl();
  const handleOpenPerson = useCallback(
    ({ entityId, entityType }: { entityId: number; entityType: EntityType }) => {
      onShowEntityView({ entityId, entityType });
    },
    [onShowEntityView]
  );

  if (!value) {
    return null;
  }

  return (
    <div>
      <EntityChip
        entityId={value.id}
        entityType={EntityType.PERSON}
        key={value.id}
        name={value.name ?? ""}
        onClick={handleOpenPerson}
        tooltip={intl.formatMessage({
          id: "grid.primaryPersonCell.open",
          defaultMessage: "Open primary person",
          description: "Open primary Person tooltip",
        })}
      />
    </div>
  );
};
const mapStateToProps = {
  onShowEntityView: showEntityView,
};

export default connect(null, mapStateToProps)(PrimaryPersonCellRenderer);
